import { createContext, useEffect, useState } from "react";


export const ParameterContext = createContext();

export const ParameterProvider = ({ children }) => {
    const [parameters, setParameters] = useState([]);
    const [version, setVersion] = useState('');

    useEffect(() => {
        try {

            fetch(process.env.REACT_APP_BACKEND_URL + 'Parameter/GetAllParameters')
                .then((res) => {
                    const apiVersion = res.headers.get('Api-Supported-Versions');
                    const newSessionToken = res.headers.get('SessionToken');
                 
                    sessionStorage.setItem('sessionToken', newSessionToken);
                    sessionStorage.setItem('apiVersion', apiVersion);
                    localStorage.setItem('apiVersion', apiVersion);
                    res.json()
                        .then((data) => {
                            setParameters(state => {
                                let modifiedData = {};

                                let modifiedMunicipalityData = {};
                                let modifiedNomParametersData = [];

                                for (var key in data.municipality) {
                                    modifiedMunicipalityData[key.toLowerCase()] = data.municipality[key];
                                }

                                for (var parameter of data.nomParameters) {
                                    let modifiedParameter = {};

                                    for (var key in parameter) {
                                        modifiedParameter[key.toLowerCase()] = parameter[key];
                                    }

                                    modifiedNomParametersData.push(modifiedParameter);
                                }

                                modifiedData.municipality = modifiedMunicipalityData;
                                modifiedData.nomParameters = modifiedNomParametersData;

                                return modifiedData;
                            });
                        })
                })

            fetch(process.env.REACT_APP_BACKEND_URL + 'Version')
                .then((res) => {
                    res.json()
                        .then((data) => {
                            setVersion(data.version);
                        })
                })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [])

    return (
        <ParameterContext.Provider value={{ parameters, version }}>
            {children}
        </ParameterContext.Provider>
    )
}